/**
 * Natural sort comparator
 * drone-001, drone-002, ... drone-010 の順に並ぶ
 */
export const naturalSort = (a, b) => {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
};

/**
 * オブジェクト配列をキーでnatural sort
 */
export const naturalSortBy = (arr, key) => {
  return [...arr].sort((a, b) => naturalSort(a[key] ?? '', b[key] ?? ''));
};
